import React, { ChangeEvent, useState, useEffect } from 'react';
import actions from '@state/actions';
import { useDispatch } from 'react-redux';
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import Input from '@components/Input';

const DesignName:React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(props.value);
  const [tipLabel, setTipLabel] = useState("");
  const [isChecking, setIsChecking] = useState(false);

  const handleChangeName = (e : any) => {
    setValue(e.target.value);
    validateDesignName(e.target.value);
  }

  const getDesignByName = (name: string) => {
    let query=`?filter=c.createdBy.email='${props.userData.email}' and c.formatName='${encodeURIComponent(name.toLowerCase())}' and c.designStatus='ACTIVE'&orderby=c.name&start=0&pagelength=1`;
    
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.getDesign(query, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  } 

  const validateDesignName = async (value: string) => {
    let valid = false;

    if (value === "")
      setTipLabel("ERROR: The design name cannot be an empty value")
    else{
      setIsChecking(true);
      const repeatedDesign :any = await getDesignByName(value);

      if ( repeatedDesign && repeatedDesign.length > 0 )
        setTipLabel("ERROR: Two designs cannot share the same name");
      else{
        setTipLabel("");
        valid = true;
      }

      setIsChecking(false);
    }
    if (props.handleData) props.handleData("nameDesign", { value: value, valid: valid, change: true});
  }

  let borderColor = "";
  if (tipLabel!=="" && !isChecking) borderColor = `solid 1px ${C.RED}`;
  
  return (
    <S.Root 
      style={{margin: props.fromEditDesign && props.fromEditDesign === true ? '0px 60px 0px 60px' : '0px 78px 0px 50px'}}
    >
      <S.Title>Title</S.Title>
      <Input 
        id={"template-name"}
        placeholder={"Design name"}
        value={value}
        handleChange={(event:ChangeEvent<HTMLInputElement>) => handleChangeName(event)}
        disabled={false}
        tipLabel={isChecking ? 'Checking design name...' : tipLabel}
        tipLabelColor={isChecking ? '#8891a0' : C.RED}
        style={{
          marginTop: '16px',
        }}
        inputStyle={{
          color: C.BLACK,
          border: borderColor
        }}
      />
    </S.Root >
  );
}

export default DesignName;